<template src="./html/FilterBar.html"></template>

<script>
	import Ladda from 'ladda'

	export default {
		props: ['user', 'isAuth'],
		data () {
			return {
				languages: null,
				filter: {
					allowDate: false,
					date: null,
					text: null,
					lang_code: this.$lang.getLang(),
				}
			}
		},
		created() {
			this.init()
		},
		mounted() {
			this.initDate()
		},
		watch: {
			'filter.lang_code'() {
				this.doFilter()
			}
		},
		methods: {
			init() {
				this.getLanguages()
			},
			getLanguages() {
				this.$http.get('languages')
					.then(response => {
						this.languages = response.body
					})
			},
			keyUpdoFilter(event) {
				if(this.filter.text) {
					if(event.code == 13) {
						this.doFilter()
					} else {
						if(event.code != 32) {
							this.doFilter()
						}
					}
				} else {
					this.doFilter()
				}
			},
			doFilter() {
				if(this.filter.text) {
					this.filter.text = this.filter.text.trimStart()
				}
				if(this.filter.allowDate) {
					this.filter.date = $('#daterange').val()
				} else {
					this.filter.date = null
				}
				this.$events.fire('filterSet', this.filter)
			},
			clearData() {
				this.filter.lang_code = this.$lang.getLang()
				this.filter.text = null
				this.filter.allowDate = false
				this.filter.data = false
			},
			reset() {
				this.clearData()
				this.$events.fire('filterReset', this.filter)
			},
			initDate() {
				var year = moment().format('YY')
				var month = moment().format('MM')
				var startDate = moment([year, month - 1])
				var endDate = moment()
				$('#daterange').daterangepicker({
					"startDate": startDate.format('DD/MM/YY'),
					"endDate": endDate.format('DD/MM/YY'),
					"locale": {
						"format": "DD/MM/YY",
						"separator": " - ",
						"applyLabel": "Aceptar",
						"cancelLabel": "Cancelar",
						"fromLabel": "From",
						"toLabel": "To",
						"customRangeLabel": "Custom",
						"daysOfWeek": [
							"Do",
							"Lu",
							"Ma",
							"Mi",
							"Ju",
							"Vi",
							"Sa",
						],
						"monthNames": [
							"Enero",
							"Febrero",
							"Marzo",
							"Abril",
							"Mayo",
							"Junio",
							"Julio",
							"Agosto",
							"Septiembre",
							"Octubre",
							"Noviembre",
							"Diciembre",
						],
						"firstDay": 1
					}
				})
			},
		}
	}	
</script>


// WEBPACK FOOTER //
// src/components/cms/articles/views/FilterBar.vue